import React, { useState } from "react";
import AppliedFilters from "../layout/AppliedFilters";
import SearchBar from "../layout/SearchBar";
import cx from "classnames";
import Checkbox from "./Checkbox";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsSocailListObj, getAdobeAnalyticsCustomLinkObj } from '../../analytics/analyticsObject';
import { getUrlWithoutPathname } from '../../utils/utility';

const FiltersModal = ({
  canProceed,
  showMobileSearch,
  showFiltersModal,
  setShowFiltersModal,
  selectedFilters,
  setSelectedFilters,
  appliedFilters,
  setAppliedFilters,
  filters,
  searchProps,
}) => {
  const [hiddenGroups, setHiddenGroups] = useState([]);

  const toggleGroup = (groupName) => {
    let groups = hiddenGroups.slice();
    if (groups.includes(groupName)) {
      groups = groups.filter((i) => i !== groupName);
    } else {
      groups.push(groupName);
    }
    setHiddenGroups(groups);
  };

  const icons = (group) => {
    switch (group) {
      case "PMApproach":
        return "fas fa-paper-plane";
      case "MediaType":
        return "far fa-newspaper";
      case "Industry":
        return "fas fa-industry";
      default:
        return "fas fa-paper-plane";
    }
  };

  const groupTitle = (group) => {
    switch (group) {
      case "PMApproach":
        return "Approach";
      case "MediaType":
        return "Format";
      case "Industry":
        return "Industry";
      default:
        return group;
    }
  };

  const isGroupHidden = (groupName) => {
    return hiddenGroups.includes(groupName);
  };

  const filterSelected = (checked, filter, isChild, filterParent) => {
    let sFilters = selectedFilters.slice();
    if (checked) {
      selectChildFilters(filter, sFilters, checked);
      if (!sFilters.includes(filter)) sFilters.push(filter);
      if (isChild && areAllChildrenSelected(filter, filterParent, sFilters) && !sFilters.includes(filterParent)) {
        sFilters.push(filterParent);
      }
    } else {
      selectChildFilters(filter, sFilters, checked);
      if (sFilters.includes(filter)) sFilters.splice(sFilters.indexOf(filter), 1);
      if (isChild && sFilters.includes(filterParent)) {
        sFilters.splice(sFilters.indexOf(filterParent), 1);
      }

    }
    setSelectedFilters(sFilters);
  };

  const selectChildFilters = (filter, filterArray, checked) => {
    for (let i = 0; i < filter?.children?.length; i++) {
      if (checked && !filterArray.includes(filter.children[i])) filterArray.push(filter.children[i]);
      else if (!checked && filterArray.includes(filter.children[i])) filterArray.splice(filterArray.indexOf(filter.children[i]), 1);
    }
  }

  const areAllChildrenSelected = (filter, parentFilter, filterArray) => {
    for (let i = 0; i < parentFilter?.children.length; i++) {
      if (!filterArray.includes(parentFilter.children[i]) && filter.key !== parentFilter.children[i].key) return false;
    }
    return true;
  }

  const cancelFilters = () => {
    setShowFiltersModal(!showFiltersModal);
  };

  const applyFilters = () => {
    setAppliedFilters([...selectedFilters]);
    setShowFiltersModal(!showFiltersModal);
    let selectFilters = selectedFilters.map(filter => (filter.group + ':' + filter.title))
    let selectKeys = selectedFilters.map(filter => (filter.key))
    const searchFilterString = selectFilters?.length > 0 ? selectFilters.join(", ") : ""

    let contEventObj = getAdobeAnalyticsEventObject(
      "search-filter",
      "search-filter",
    );
    let contObj = getAdobeAnalyticsSocailListObj({
      search: {
        searchFilter: searchFilterString
      }
    });
    let linkUrl = `${getUrlWithoutPathname()}` + '#' + selectKeys
    let customLObj = getAdobeAnalyticsCustomLinkObj(
      'filter',
      "filter-section",
      linkUrl
    );
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    pushDatatoAdobeLayer({
      onContClickData: { ...contEventObj, ...contObj },
      customLinkData: { ...customEventObj, ...customLObj },
      pageData: false,
      adobePushTracking: false,
    });
  };
  // Filter "Topic, SubTopics" in filters array to hide Topic, SubTopics in filter modal view
  const { Topic, SubTopic, ...filterGroups } = filters;

  return (
    <div
      className={cx("fixed z-40 w-full bg-gray-100", {
        "modal-height": showFiltersModal,
      })}
      style={
        showFiltersModal
          ? { height: "100vh", overflow: "hidden", overflowY: "auto" }
          : {}
      } adoberegion="filter-section"
    >
      <div id="applied-filters-bar" style={{ paddingTop: "90px" }}>
        {showMobileSearch && (
          <div className="md:hidden px-5">
            <SearchBar
              canProceed={canProceed}
              searchProps={searchProps}
            ></SearchBar>
          </div>
        )}

        <div className="w-full pb-5">
          <AppliedFilters
            filters={filters}
            showFiltersModal={showFiltersModal}
            setShowFiltersModal={setShowFiltersModal}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            appliedFilters={appliedFilters}
            setAppliedFilters={setAppliedFilters}
            filterSelected={filterSelected}
            applyFilters={applyFilters}
            areAllChildrenSelected={areAllChildrenSelected}
          />
        </div>
      </div>

      {showFiltersModal && (
        <div className="flex flex-col p-8 items-center md:items-start md:flex-row justify-between w-full filter-margin" adoberegion="filter-section">
          {Object.keys(filterGroups).map((groupName) => (
            <div
              key={groupName}
              className={`mx-3 mb-3 md:mr-0 w-full md:w-1/${Object.keys(filterGroups).length
                }`}
            >
              {/* Header */}
              <div
                onClick={() => {
                  toggleGroup(groupName);
                }}
                className="mb-2 text-black text-sm lg:text-lg font-normal cursor-pointer hover:text-blue-500 btn-font"
              >
                <i className={icons(groupName)}></i>&nbsp;
                <span>{groupTitle(groupName)}</span>
              </div>
              {/* Filter */}

              {!isGroupHidden(groupName) && (
                <div className="border-solid border-t border-black pt-4">

                  {/* WARNING: Filter will not show if there is no post assigned to it */}

                  {
                    <>
                      {filterGroups[groupName].map((f) => {
                        return (
                          <span key={f.key}>

                            <Checkbox
                              key={`${f.key}_checkbox`}
                              label={f.title}
                              name={f.key}
                              onChange={(e) => filterSelected(e.target.checked, f)}
                              checked={selectedFilters.includes(f)}
                            />


                            {f?.children?.map((f2) => {

                              f2.parentKey = f.key

                              return (
                                <Checkbox
                                  key={f2.key}
                                  label={f2.title}
                                  name={f2.key}
                                  onChange={(e) => filterSelected(e.target.checked, f2, true, f)}
                                  checked={selectedFilters.includes(f2)}
                                  className="ml-6"
                                />

                              )
                            })}

                          </span>
                        )
                      })}

                    </>
                  }

                </div>
              )}
            </div>
          ))}

          <div className="flex flex-no-wrap items-center mt-5 md:mt-0 sm:hidden filter-font justify-end w-full">
            <span
              onClick={() => cancelFilters()}
              className="cursor-pointer mr-3 main-color"
            >
              Cancel
            </span>
            <button
              onClick={() => applyFilters()}
              className="btn py-3 px-4 text-white bg-main"
            >
              APPLY
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FiltersModal;
